import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  }
`;


const ServiceTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes.large};
  color: ${({ theme }) => theme.colors.primary};
`;

const ServiceDescription = styled.p`
  margin-top: 10px;
  font-size: ${({ theme }) => theme.fontSizes.medium};
`;

const ServiceCard = ({ title, description }) => (
  <Card>
    <ServiceTitle>{title}</ServiceTitle>
    <ServiceDescription>{description}</ServiceDescription>
  </Card>
);

export default ServiceCard;
